import AV, { User } from 'leancloud-storage';
AV.init({
    appId: "xl5PtXUU3LluVijMH2eF4X9C-gzGzoHsz",
    appKey: "hvdyKoPL9MSbM5o2S9WGFTxW",
    serverURL: "https://xl5ptxuu.lc-cn-n1-shared.com"
});
// 用户登陆注册接口层
const Auth = {
    register(username, password) {
        let user = new User();
        user.setUsername(username);
        user.setPassword(password);
        return new Promise((resolve, reject) => {
            user.signUp().then(loginedUser => { resolve(loginedUser) }, error => { reject(error) })
        })
    },
    login(username, password) {
        return new Promise((resolve, reject) => {
            User.logIn(username, password).then(loginedUser => { resolve(loginedUser) }, error => { reject(error) })
        })

    },
    logout() {
        User.logOut();
    },
    getCurrentUser() {
        return User.current();
    }
};
// 上传服务器接口层,图片的增删改查操作，目前只有增加和查询操作
const Uploader = {
    // 传递文件，和文件名参数，实现图片在leancloud的保存
    add(file, filename) {
        const item = new AV.Object('Image');
        const avFile = new AV.File(filename, file);
        item.set('filename', filename);
        item.set('owner', AV.User.current());
        item.set('url', avFile);
        // 为了后续调用方便，我们返回一个Promise对象
        return new Promise((resolve, reject) => {
            // serverFile就是在服务器上保存的图片对象
            item.save().then((serverFile) => {
                resolve(serverFile);
            }, error => {
                reject(error);
            })
        })

    },
    // 参数为页数和历史记录数
    find({ page = 0, limit = 10 }) {
        const query = new AV.Query('Image');
        query.limit(limit);
        // 每页跳过的查询数
        query.skip(page * limit);
        query.equalTo('owner', AV.User.current());
        // 根据创建时间降序排列
        query.descending('createdAt');
        return new Promise((resolve, reject) => {
            query.find()
                .then((results) => resolve(results))
                .catch((err) => reject(err));
        })
    }
}

window.Uploader = Uploader;

export { Auth, Uploader };

